query RefCode3($Ref3CodeFilter: Reference3CodeFilter) {
  reference3Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref3CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
}
